module.exports = __webpack_public_path__ + "static/media/composition.a450455c.PNG";